import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UmsService } from '../ums.service';
import { ComplaintFormComponent } from '../complaint-form/complaint-form.component';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { PageEvent } from '@angular/material/paginator';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertBoxComponent } from '../alert-box/alert-box.component';
import { ModalpopService } from '../modalpop.service';
import { FormBuilder, FormControl } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-complaint',
  templateUrl: './complaint.component.html',
  styleUrls: ['./complaint.component.scss']
})
export class ComplaintComponent implements OnInit {
  complaintSearchForm
  complaintList: any;
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 20];
  currentPage = 1;
  totalItems = 0;
  dialogRef: MatDialogRef<any>;
  setIntervalSearch: any;
  userPermission: any;
    utp: string;
      ComplaintCreate=true;
  ComplaintUpdate=true;
  constructor(private dialog: MatDialog,public umsService: UmsService,public router: Router,
    private modalPopupService: ModalpopService,private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private datePipe: DatePipe,
  ) { }
  // convertUTCToIST(dateString: string): string {
  //   const utcDate = new Date(dateString); // Convert string to Date object
  //   const istDate = new Date(utcDate.getTime() - (330 * 60 * 1000)); // IST is UTC + 5:30
  //   return this.datePipe.transform(istDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
  // }
  ngOnInit(): void {
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));
    this.utp = sessionStorage.getItem('usertypeee');
    if(this.utp !== 'Super Admin' && this.utp !== 'Admin'){
      this.userPermission.forEach(element => {
      if(element.PageName == 'Grievance' && element.PCreate == false)
      {
          this.ComplaintCreate = false;  
      }
      if(element.PageName == 'Grievance' && element.PUpdate == false)
      {
          this.ComplaintUpdate = false;  
      }   
      
    });
  }
    this.getComplaintData();
    this.complaintSearchForm = this.fb.group({
      SearchString: new FormControl('')
    });
  }
  onPageChange(event: PageEvent): void {
    this.pageSize = event.pageSize;
    const newPageIndex = event.pageIndex + 1;
    this.currentPage = newPageIndex;
    this.getComplaintData();
    this.keypress();
  }
    
  keypress() {
    if(this.setIntervalSearch){
      clearTimeout(this.setIntervalSearch);
    }
    this.setIntervalSearch = setTimeout(()=>{
      this.complaintList = [];
      let payload = {}
      payload['SearchString'] = this.complaintSearchForm.value['SearchString'];
      payload['PageSize'] = this.pageSize;
      if (payload['SearchString'] === "") {
        payload['PageNumber'] = this.currentPage;
      } else {
        payload['PageNumber'] = 1;
      }
      this.umsService.getComplaint(payload).subscribe(res => {
        if(res.status){
          this.complaintList = res.data;
          this.totalItems = res.data[0].TotalRecords;
        }
        else{
          this.complaintList = [];
          this.totalItems = 0;
        }
       
      }, (ERROR: HttpErrorResponse) => {
        this.complaintList = [];
      });
    },1000)
   
  }
  // getComplaintData() {
  //   // this.spinner.show();
  //   const payload = {};
  //   payload['PageSize'] = this.pageSize;
  //   payload['PageNumber'] = this.currentPage;
  //   payload['UserID'] = sessionStorage.getItem('userId')
  //   this.umsService.getComplaint(payload).subscribe(res => {
  //     // this.spinner.hide();
  //     this.complaintList = res.data;
  //     this.totalItems = res.data[0].TotalRecords;
  //   }, (ERROR: HttpErrorResponse) => {
  //     this.complaintList = [];
  //     let data = {}
  //     // this.spinner.hide();
  //     data['message'] = ERROR.error.message
  //     data['title'] = 'Information'
  //     data['icon'] = 'fas fa-box-open'
  //     this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
  //   });
  // }
  getComplaintData() {
    // this.spinner.show();
    const payload = {};
    payload['PageSize'] = this.pageSize;
    payload['PageNumber'] = this.currentPage;
    payload['UserID'] = parseInt(sessionStorage.getItem('userId'));
    
    // Check user permission (University or Complaint user)
    this.userPermission = JSON.parse(sessionStorage.getItem("userPermission"));

    this.umsService.getComplaint(payload).subscribe(res => {
      // this.spinner.hide();
      if (res.status) {
        // For Complaint user
        if (this.userPermission[0].CgUi == 'C') {
          let complaintList = res.data.filter(complaint => complaint.CgCode == this.userPermission[0].CgId);
          this.complaintList = complaintList;
          this.totalItems = complaintList.length;
        } 
        // For University user
        else if (this.userPermission[0].CgUi == 'U') {
          this.complaintList = res.data;
          this.totalItems = res.data[0].TotalRecords || res.data.length;
        }
      }
    }, (ERROR: HttpErrorResponse) => {
      this.complaintList = [];
      let data = {};
      // this.spinner.hide();
      data['message'] = ERROR.error.message;
      data['title'] = 'Information';
      data['icon'] = 'fas fa-box-open';
      this.dialogRef = this.modalPopupService.openPopup<AlertBoxComponent>(AlertBoxComponent, data);
    });
}

  redirect(to): void {
    this.router.navigate([to]);
  }
//   details(data){
//     this.router.navigate(['complaint-form'],
//       { queryParams: data}
// ); 
//   }
details(data: any) {
  localStorage.setItem('grivenceData', JSON.stringify(data));
  this.router.navigate(['complaint-form'],
     { state: { data } });
}

convertUTCToIST(dateString: string): string {
  const utcDate = new Date(dateString); // Convert string to Date object
  // Directly use the date pipe with 'Asia/Kolkata' time zone
  return this.datePipe.transform(utcDate, 'dd/MM/yyyy h:mm:ss a', 'Asia/Kolkata') || '';
}
}
